import React from "react";
import { Box, Slider } from "@mui/material";

export interface FilterSliderProps {
  value: number | number[];
  marks?: any[];
  min?: number;
  max?: number;
  step?: number;
  name?: string;
  note?: string;
  disabled?: boolean;
  track?: false | "normal" | "inverted" | undefined;
  onChange?: (value: number | number[]) => void;
  onBlur?: () => void;
}

const FilterSlider: React.FC<FilterSliderProps> = ({
  value,
  min = 0,
  max = 1000,
  step = 1,
  name = "speed-range",
  disabled,
  track = "normal",
  marks = [],
  note = "",
  onChange,
  onBlur,
}) => {
  const valuetext = (value: number) => `${Math.floor(value)}`;

  return (
    <Box paddingTop={8} paddingX={10}>
      <p style={{ textAlign: "center", margin: "-10px 0 0 0", minHeight: "10px" }}>{note}</p>
      <Slider
        track={track}
        value={value}
        min={min}
        max={max}
        step={step}
        name={name}
        marks={marks}
        disabled={disabled}
        valueLabelDisplay={disabled ? "off" : "on"}
        valueLabelFormat={valuetext}
        getAriaLabel={valuetext}
        getAriaValueText={valuetext}
        aria-labelledby="slider"
        onChange={(_, value) => onChange && onChange(value)}
        onChangeCommitted={() => onBlur && onBlur()}
        data-testid="filterSlider"
      />
    </Box>
  );
};

export default FilterSlider;
